var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.579,
    height: 180.384,
    viewBox: "0 0 165.579 180.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.416,
    x2: 0.5,
    y2: 0.824,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#169ca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#0d778d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#075c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#034c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02466a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.504,
    y1: -9.523,
    x2: 0.504,
    y2: 3.965,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.501,
    y1: -6.456,
    x2: 0.501,
    y2: 1.961,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.492,
    y1: -13.672,
    x2: 0.492,
    y2: 7.369,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.505,
    y1: -196.312,
    x2: 0.505,
    y2: 42.415,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#8dc340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.505,
    y1: -201.437,
    x2: 0.505,
    y2: 127.34,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#8dc340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#79b9e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463e97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#1dbbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02466a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(-262.8 -190.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7359",
    "data-name": "Rectangle 7359",
    width: 55.57,
    height: 72.669,
    transform: "translate(320.833 248.716)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M509.119,238.327V213.189h0c0-12.6-11.663-22.789-26.016-22.789-14.381,0-26.016,10.191-26.016,22.789v25.053a3.694,3.694,0,0,0-1.387,2.887c0,.113.028.226.028.368a3.723,3.723,0,0,0,7.417,0c0-.113.028-.226.028-.368a3.733,3.733,0,0,0-1.274-2.8V213.132c0-10.248,9.483-18.542,21.175-18.542s21.175,8.294,21.175,18.542v25.082a3.758,3.758,0,0,0-1.359,2.888c0,.113.028.226.028.368a3.723,3.723,0,0,0,7.417,0c0-.113.028-.226.028-.368A3.427,3.427,0,0,0,509.119,238.327Z",
    transform: "translate(-138.292)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M585.083,508.1a3.1,3.1,0,0,1-.283.311A3.1,3.1,0,0,0,585.083,508.1Z",
    transform: "translate(-230.845 -227.763)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M458.524,323.4h-5.039v9.483a5.543,5.543,0,0,1,1.3,3.6,5.633,5.633,0,1,1-11.267,0,5.536,5.536,0,0,1,1.359-3.652v-9.4H406.323v9.512a5.626,5.626,0,1,1-9.993,3.539,5.709,5.709,0,0,1,1.387-3.708V323.4h-5.124a7.654,7.654,0,0,0-7.615,6.737l-9.427,77.991a7.317,7.317,0,0,0,.113,2.491c2.972-.679,5.86-1.472,8.634-2.321,1.868-.566,3.68-1.189,5.464-1.84q3.992-1.444,7.728-3.142c.821-.368,1.642-.764,2.463-1.132,1.614-.764,3.2-1.585,4.756-2.406l1.359-.764c-1.076-1.812-1.925-3.255-2.689-4.643-.849-1.529-1.557-3.6-.226-4.9a3.212,3.212,0,0,1,4.5.028l.085.085,4.728,5.548c.113-.057.2-.141.311-.2.453-.311.934-.623,1.387-.934.764-.51,1.5-1.047,2.265-1.585,1.076-.764,2.123-1.529,3.142-2.321.085-.057.17-.142.283-.226l.34-25.676a3.257,3.257,0,0,1,3.2-3.227,3.122,3.122,0,0,1,2.293.991,3.2,3.2,0,0,1,.906,2.321l-.255,20.156c1.076-.963,2.123-1.953,3.142-2.944l.028-2.35a3.257,3.257,0,0,1,3.2-3.227,3.181,3.181,0,0,1,1.67.481c.142-.141.283-.311.425-.453a3.1,3.1,0,0,1,.283-.311c.934-1.047,1.84-2.095,2.718-3.114.849-.991,1.642-2.01,2.435-3,.651-.821,1.274-1.642,1.868-2.435q3.355-4.5,6.115-8.917c.255-.425.51-.821.764-1.246.4-.651.793-1.3,1.161-1.953.255-.453.538-.906.793-1.331,1.246-2.18,2.378-4.3,3.425-6.341.255-.51.51-.991.736-1.5.226-.481.481-.963.708-1.415.255-.51.481-1.019.708-1.529.2-.425.4-.878.594-1.3l.679-1.529a125.346,125.346,0,0,0,5.492-15A7.958,7.958,0,0,0,458.524,323.4ZM423.28,354.455a6.826,6.826,0,0,0-6.058,9.993l.085.17V369.6l-1.415-1.529a10.055,10.055,0,0,1,.594-14.183,10.04,10.04,0,0,1,14.183.566,9.991,9.991,0,0,1,.142,13.447l-1.387,1.585v-5.209l.085-.17a6.838,6.838,0,0,0-1.161-7.5A7.156,7.156,0,0,0,423.28,354.455Zm10.446,18.174a14.091,14.091,0,0,1-3.142,2.18l-1.161.594v-3.567l.368-.226a14.6,14.6,0,0,0,1.784-1.331,11.976,11.976,0,0,0,3.907-8.493,12.133,12.133,0,0,0-3.227-8.776,12.256,12.256,0,0,0-8.974-3.935,12.213,12.213,0,0,0-8.946,20.5,11.751,11.751,0,0,0,2.633,2.095l.4.227v3.623l-1.161-.594a14.715,14.715,0,0,1-4.218-3.2,15.411,15.411,0,1,1,21.741.906Z",
    transform: "translate(-80.79 -95.349)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M509.863,560.919c-.736.538-1.5,1.047-2.265,1.585-.453.311-.934.623-1.387.934-.113.057-.2.141-.311.2l4.5,5.265a1.567,1.567,0,0,0,1.189.538,1.6,1.6,0,0,0,.51-.085,1.562,1.562,0,0,0,1.019-1.444l.113-9.512a2.464,2.464,0,0,1-.283.227C511.986,559.391,510.939,560.155,509.863,560.919Z",
    transform: "translate(-174.281 -263.823)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M624.618,412.287l-6.766-55.91L615.191,334.3a7.6,7.6,0,0,0-2.888-5.1h0a123.565,123.565,0,0,1-5.492,15l-.679,1.529c-.2.425-.4.849-.594,1.3-.227.51-.481,1.019-.708,1.529-.226.481-.453.934-.708,1.415s-.481.991-.736,1.5c-1.047,2.067-2.18,4.19-3.425,6.341-.255.453-.51.878-.793,1.331-.368.651-.764,1.3-1.161,1.953-.255.425-.51.821-.764,1.246q-2.76,4.416-6.115,8.917c-.623.821-1.246,1.642-1.868,2.435-.793.991-1.585,2.01-2.435,3-.878,1.047-1.783,2.095-2.718,3.114a3.1,3.1,0,0,1-.283.311c-.142.142-.283.311-.425.453.028,0,.028.028.057.028a3.223,3.223,0,0,1,1.472,2.774l-.142,11.069a1.59,1.59,0,0,0,1.529,1.585,1.571,1.571,0,0,0,1.585-1.529l.113-7.9a3.257,3.257,0,0,1,3.2-3.227,3.122,3.122,0,0,1,2.293.991,3.2,3.2,0,0,1,.906,2.321l-.142,11.069a1.59,1.59,0,0,0,1.529,1.585,1.571,1.571,0,0,0,1.585-1.529l.085-7.077a3.257,3.257,0,0,1,3.2-3.227,3.122,3.122,0,0,1,2.293.991,3.2,3.2,0,0,1,.906,2.321l-.227,16.617c-.028,2.859-1.529,8.747-2.831,13.418h16.164A7.658,7.658,0,0,0,624.618,412.287Z",
    transform: "translate(-229.842 -99.507)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M411.852,599.417c-1.67-2.6-3.539-5.577-5.407-8.663-.057-.085-.085-.17-.142-.255l-1.359.764c-1.529.821-3.114,1.642-4.756,2.406-.821.4-1.642.764-2.463,1.132q-3.737,1.7-7.728,3.142c-1.783.651-3.6,1.274-5.464,1.84-2.774.878-5.662,1.642-8.634,2.321a7.688,7.688,0,0,0,7.5,6.086h33.772a4.118,4.118,0,0,0-.283-.51C415.589,605.277,413.777,602.446,411.852,599.417Z",
    transform: "translate(-81.083 -286.836)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M554.8,534.292a1.59,1.59,0,0,0,1.529,1.585,1.572,1.572,0,0,0,1.585-1.529L558,528.8c-1.019.991-2.067,1.982-3.142,2.944Z",
    transform: "translate(-209.338 -242.603)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M583.3,509.753c.142-.141.283-.311.425-.453-.142.142-.283.283-.425.453Z",
    transform: "translate(-229.77 -228.623)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M583.3,509.753c.142-.141.283-.311.425-.453-.142.142-.283.283-.425.453Z",
    transform: "translate(-229.77 -228.623)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7360",
    "data-name": "Rectangle 7360",
    width: 12.484,
    height: 32.612,
    transform: "translate(415.725 338.172)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M620.474,784.081c-1.925,0-3.624,1.217-3.284,4.02h19.844l5.1-4.048Q631.3,784.01,620.474,784.081Z",
    transform: "translate(-254.035 -425.583)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M322.734,744.4H314.1v11.182h6.539A23.619,23.619,0,0,1,322.734,744.4Z",
    transform: "translate(-36.778 -397.169)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M474.937,815.146a3.139,3.139,0,0,0-3.737.085,4.194,4.194,0,0,0-1.5,2.972h6.822A3.35,3.35,0,0,0,474.937,815.146Z",
    transform: "translate(-148.329 -447.476)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M472.275,810.593a4.9,4.9,0,0,0-2.576-.793,4.623,4.623,0,0,0-2.689.934,5.513,5.513,0,0,0-2.01,4.076h.651a5.1,5.1,0,0,1,1.755-3.567,3.738,3.738,0,0,1,4.5-.113,4.068,4.068,0,0,1,1.9,3.68h.651A4.681,4.681,0,0,0,472.275,810.593Z",
    transform: "translate(-144.959 -444.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M473.556,812.861a3.781,3.781,0,0,0-4.5.113,4.838,4.838,0,0,0-1.755,3.567h8.153A4.011,4.011,0,0,0,473.556,812.861Zm-4.1.651a3.1,3.1,0,0,1,3.737-.085,3.351,3.351,0,0,1,1.585,3.057h-6.822A4.3,4.3,0,0,1,469.451,813.512Z",
    transform: "translate(-146.608 -445.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M805.8,674.3v8.294h.226l10.446-8.294Z",
    transform: "translate(-389.283 -346.913)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M705.871,788.048a6.744,6.744,0,0,0-.962-2.576,2.519,2.519,0,0,0-2.067-1.444c-3.482,0-6.964,0-10.446-.028l-5.1,4.048Z",
    transform: "translate(-304.329 -425.559)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M411.591,733.392a13.912,13.912,0,0,0-1.7-6.936c-1.755-3.312-4.275-5.1-7.53-5.435-.34-.028-.679-.057-1.019-.057-10.729-.028-21.486-.028-32.216,0a10.471,10.471,0,0,0-2.8.4,6.336,6.336,0,0,0-3.793,3.312V712.047h-10.3v24.374h-6.086V712.076h-9.908v24.346h-6.511V720.993h-9.767v15.428h-5.577a22.122,22.122,0,0,0-1.755-5.1,24.044,24.044,0,0,0-1.953-3.029,18.185,18.185,0,0,0-4.02-4.048,17.337,17.337,0,0,0-6.313-2.916,12.788,12.788,0,0,0-5.181-.227.365.365,0,0,0-.34.34,32.629,32.629,0,0,0-.708,4.954,17.805,17.805,0,0,0,.793,5.973c.679,0,1.415-.028,2.151,0a20.035,20.035,0,0,1,2.236.113,3.981,3.981,0,0,1,3.425,3.907h-6.964a14.487,14.487,0,0,1-1.047-1.953,19.263,19.263,0,0,1-1.331-8.125,23.916,23.916,0,0,1,1.331-6.794,14.191,14.191,0,0,1,2.208-4.077,8.567,8.567,0,0,1,2.916-2.208c.368-.17.821-.34.878-.906a1.265,1.265,0,0,0-.878-.34,7.735,7.735,0,0,0-1.387.17,12.339,12.339,0,0,0-4.614,1.529,16.793,16.793,0,0,0-5.917,5.718,21.158,21.158,0,0,0-3.4,10.7,21.439,21.439,0,0,0,.708,6.285H272.482V712.047H262.8v32.64h57.241a5.66,5.66,0,0,1,2.01-4.077,4.374,4.374,0,0,1,2.689-.934,4.728,4.728,0,0,1,2.576.793,4.779,4.779,0,0,1,2.208,4.246h82.067C411.591,740.922,411.563,737.157,411.591,733.392Zm-48.436,3.029c-.34-2.8,1.359-3.992,3.284-4.02,7.219-.028,14.438-.057,21.628-.028,3.482,0,6.964,0,10.446.028a2.519,2.519,0,0,1,2.067,1.444,6.744,6.744,0,0,1,.963,2.576Z",
    transform: "translate(0 -373.931)",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M689.538,756.171a13.912,13.912,0,0,0-1.7-6.936c-1.755-3.312-4.275-5.1-7.53-5.435l-14.3,11.352c3.482,0,6.964,0,10.446.028a2.519,2.519,0,0,1,2.067,1.444,6.745,6.745,0,0,1,.963,2.576H660.946L650.5,767.495h39.038C689.538,763.673,689.51,759.908,689.538,756.171Z",
    transform: "translate(-277.947 -396.739)",
    opacity: 0.1,
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M815.4,722.165V712.2H803v32.612h12.654C815.371,737.225,815.4,729.582,815.4,722.165Z",
    transform: "translate(-387.275 -374.084)",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M817.272,674.3h-.226L806.6,682.594h10.672Z",
    transform: "translate(-389.856 -346.913)",
    fill: "#326ab2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M817.272,674.3h-.226L806.6,682.594h10.672Z",
    transform: "translate(-389.856 -346.913)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(415.725 326.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M815.484,681.38H803V671.5h12.484Zm-11.8-.679h11.1v-8.493h-11.1Z",
    transform: "translate(-803 -671.5)",
    fill: "#b6be34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(419.15 327.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M819.318,677.4a1.237,1.237,0,0,1-.708.651,1.854,1.854,0,0,0-.849.708,1.472,1.472,0,0,0,.793.453,2.73,2.73,0,0,1,.878.368.9.9,0,0,1,.425.764,1.512,1.512,0,0,1-.142.566,3.954,3.954,0,0,1-2.888,2.208c-.566.085-1.132.17-1.727.283l1.529-.679c.51-.226,1.019-.481,1.5-.736.142-.085.227-.17.227-.255,0-.028-.028-.057-.057-.085-.2-.113-.4-.2-.623-.311s-.425-.2-.623-.311a1,1,0,0,1-.595-.906,2.746,2.746,0,0,1,.708-1.529,13.525,13.525,0,0,1,2.01-2.236,3.7,3.7,0,0,1,.849-.453Z",
    transform: "translate(-815.1 -675.9)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosvg);
export default __webpack_public_path__ + "static/media/logo svg.3d5d4cc248e1eb84d6f0221616a31519.svg";
export { ForwardRef as ReactComponent };